import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-radio-input-group',
	templateUrl: './radio-input-group.component.html',
	styleUrls: ['./radio-input-group.component.scss'],
	host: {
		class: 'app-radio-input-group'
	},
	providers: [
		{
			/**
			 * Custom Control value accessor
			 */
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => RadioInputGroupComponent),
			multi: true
		}
	]
})
export class RadioInputGroupComponent implements OnInit, ControlValueAccessor {
	@Input() _value = '';
	@Input() label: string;
	@Input() inline: boolean = false;
	@Input() name: string;
	@Input() options: { label: string, selected?: boolean, id: string }[];

	@Output() optionChanged = new EventEmitter();

	propagateChange = (_: any) => { };

	constructor() { }

	@Input()
	set value(val: any) {

		for (const option of this.options) {
			if (val && (option.id == val || option.id == val.id)) option.selected = true;
		}

		this._value = val;
		this.propagateChange(this._value);
	}

	get value() {
		return this._value;
	}


	ngOnInit() {
	}

	trackByRadioId(radioBttn) {
		return radioBttn.id;
	}

	onRadioChange(event) {
		let activeOption = null;

		this.options.forEach((option) => {
			if (!event[option.id]) {
				option['selected'] = false;
			} else {
				activeOption = option.id;
				option['selected'] = true;
			}
		});

		this.optionChanged.emit(activeOption);
	}

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void { }

	writeValue(value: any) {
		this.value = value;
	}
}
